import { useSelector } from "react-redux";

import Button from "components/Button";
import ChunkUploadFile from "components/ChunkUploadFile";
import { CUSTOMER_CATEGORY } from "constants/base";
import { CREDIT_LIST } from "constants/haulpay";
import { UPLOAD_DOCUMENT_URLS } from "constants/routes";
import useDeviceType from "hooks/useDeviceType";
import { useUserFeature } from "hooks/useUserFeature";
import { ICreditItem } from "models/HaulPay";
import { selectUserDetails } from "store/user/selector";
import CreditStatus from "./CreditStatus";
import styles from "./style.module.scss";

interface IProps {
  data: ICreditItem;
  isEdit?: boolean;
  setSelectedData?: (data: any) => void;
  addCustomer?: (credit_approved: string, id: string) => void;
  goToHistory?: (data: any) => void;
  toggleWarningModal?: VoidFunction;
}

export default function CardFooter({
  data,
  addCustomer,
  goToHistory,
  isEdit = false,
  setSelectedData,
  toggleWarningModal
}: Readonly<IProps>) {
  const { isBroker } = useUserFeature();
  const { isDesktop } = useDeviceType();
  const userDetails = useSelector(selectUserDetails);

  const credit = CREDIT_LIST.find((item) => item.value === data.credit_approved)?.label;
  const isShowUploader =
    isDesktop && isEdit && isBroker && userDetails?.allow_co_broker_shipper_debtor;

  const handleViewHistory = () => goToHistory && goToHistory(data);
  const handleReviewCredit = () => {
    setSelectedData?.({
      id: data.id,
      credit_approved: data.credit_approved,
      dba: data.dba
    });
    addCustomer?.(data.credit_approved, data.id);
  };
  const handleRequestIncrease = () => {
    setSelectedData?.({
      relationship_id: data.relationship_id,
      credit_available: data.credit_available,
      dba: data.dba
    });
    toggleWarningModal?.();
  };

  const RenderUploader = () =>
    isShowUploader && (
      <ChunkUploadFile
        className="h-10 p-0 border-none w-fit bg-none"
        categories={CUSTOMER_CATEGORY}
        visibility
        urlCallback={UPLOAD_DOCUMENT_URLS({ factoring_id: data.relationship_id }).CUSTOMER}
        onUploadFinished={() => {}}
      />
    );

  const RenderButtons = () => (
    <div className="flex gap-6 !ml-auto">
      {isDesktop && (
        <>
          <button type="button" className="text-primary" onClick={handleViewHistory}>
            View History
          </button>
          {data.credit_approved === "pending" && (
            <button type="button" className="text-primary" onClick={handleReviewCredit}>
              Review Credit
            </button>
          )}
          <Button type="button" variant="outline" onClick={handleRequestIncrease}>
            Request Increase
          </Button>
        </>
      )}
      <Button
        type="submit"
        className="w-fit text-sm !h-9 desktop:!h-11 desktop:!px-8 !px-5 col-span-5">
        Save
      </Button>
    </div>
  );

  const RenderAddCustomerButton = () => (
    <Button
      type="button"
      className="w-fit text-sm !h-9 desktop:!h-11 desktop:rounded-lg !px-5 col-span-5 desktop:!ml-auto"
      onClick={handleReviewCredit}>
      Add Customer
    </Button>
  );

  return data.credit_approved ? (
    <div className={styles.footer}>
      <RenderUploader />
      {!isDesktop && <CreditStatus credit={credit} credit_approved={data.credit_approved} />}
      {isEdit ? (
        <RenderButtons />
      ) : data.is_connected ? (
        <span className="col-span-4 my-auto text-error mobile:text-xs desktop:!ml-auto">
          Already Connected
        </span>
      ) : (
        <RenderAddCustomerButton />
      )}
    </div>
  ) : null;
}
